import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CreateShipmentASN } from '../../../../models/shipment-asn';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { addDays, addHours, differenceInDays, differenceInHours } from 'date-fns';
import { PurchaseOrderService } from '../../../../service/vendor/purchase-order.service';
import { an } from '@fullcalendar/core/internal-common';
import { NavigationExtras, Router } from '@angular/router';
import { jsPDF } from 'jspdf';
import * as QRCode from 'qrcode';
import autoTable from 'jspdf-autotable';


interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

export interface ScheduleInvoice {
  invoice_challan_no: string;
}
export interface SelectedRow {
  poagreement_no: string;
  schedule_invoice: ScheduleInvoice[];
}
interface ASNDetail {
  invoice:string;
  packing_type:string;
  total_number:string;
  total_net_weight:string;
  total_gross_weight:string;
  driver:string;
  vehicle:string;
  deliver_from:string;
  deliver_to:string;
  route:string;
  expected_delivery_date:string;
}
@Component({
  selector: 'app-create-shipment-asn',
  templateUrl: './create-shipment-asn.component.html',
  styleUrl: './create-shipment-asn.component.scss',
})
export class CreateShipmentAsnComponent implements OnInit {
  filteredUQCCode: any[] = [];
  middlePortion: string = '';
  DriverListOfData: any[] = [];
  vehicleListOfData: any[] = [];
  existingInvoices: string[] = [];
  selectedUQCCode: any;
  UQCCode: any[] = ['BDL', 'BKL', 'BOU', 'BOX', 'BTL', 'BUN', 'CAN', 'CBM', 'CCM', 'CMS', 'CTN', 'DOZ', 'DRM', 'GGR', 'GMR', 'GRS', 'GYD', 'KGS', 'KLR', 'KME', 'MLT', 'MTR', 'MTS', 'NOS', 'PAC', 'PCS', 'PRS', 'QTL', 'ROL', 'SET', 'SQF', 'SQM', 'SQY', 'TBS', 'TGM', 'THD', 'TON', 'TUB', 'UGS', 'UNT', 'YDS', 'OTH',];
  minDateValue!: Date;
  createShipmentAsnForm!: FormGroup;
  shipmentASN: CreateShipmentASN = {};
  selectedRows: SelectedRow[] = [];
  selectedScopes: any[] = [];
  loadingPoints: any[] = [];
  unloadingPoints: any[] = [];
  packingTypes: any[] = [];
  vehicleNoList: any[] = [];
  vehicleTypeList: any[] = ['Small', 'Large', 'Medium', '12 Tyre', '15 Tyre', '16 Tyre', 'Other'];
  // route: any[] = [];
  driverList: any[] = [];
  plantList: any[] = [];
  deliverFromList: any[] = [];
  routeList: any[] = [];
  plantInPo: any[] = [];
  selectedPlants: any[] = [];
  selectedASNScheduleDeliveries: any[] = [];
  cols3: any[] = [];
  selectedRowIndex: number | null = null;

  driverOtherSelected: boolean = false;
  vehicleOtherSelected: boolean = false;
  isTokenCreateDialog: boolean = false;
  currentRount:any
  asn_name:string=''
  plant:string=''
  vendor:string=''
  invoice:string = ''
  invoice_callan_no:string = ''

  duration: string = ''

  selectedASNForPdf!: ASNDetail;


  constructor(
    private formBuilder: FormBuilder,
    private shipment_asn: ShipmentASN,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private purchaseOrder: PurchaseOrderService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadExistingInvoices();
    this.minDateValue = new Date();

    // this.shipment_asn
    //   .getLoadingPointList()
    //   .then((response) => {
    //     this.loadingPoints = response.message;
    //   })
    //   .catch((error) => {
    //     console.error('Error fetching loading points:', error);
    //   });

    // this.shipment_asn
    //   .getUnloadingPointList()
    //   .then((response) => {
    //     this.unloadingPoints = response.message;
    //   })
    //   .catch((error) => {
    //     console.error('Error fetching unloading points:', error);
    //   });

    this.shipment_asn
      .getPackingTypeList()
      .then((response) => {
        this.packingTypes = response.message;
      })
      .catch((error) => {
        console.error('Error fetching packing Types:', error);
      });

    this.shipment_asn
      .getVehicleTypeList()
      .then((response) => {
        this.vehicleNoList = response.message;
      })
      .catch((error) => {
        console.error('Error fetching vehicle Types :', error);
      });
    const selectedRows = history.state.selectedRows;
    if (selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedScopes = [...this.selectedRows];
    } else {
      console.log('No selected rows found.');
    }

    this.createShipmentAsnForm = this.formBuilder.group({
      serial_no_and_batch: [''],
      invoice_challan_no: ['', [Validators.required, this.validateInvoice()]],
      invoice_date: ['', Validators.required],
      actual_delivery_date_and_time: [null],
      packing_type: ['', Validators.required],
      total_number: [''],
      total_net_weight: [''],
      total_gross_weight: [''],
      deliver_from: [''],
      deliver_to: [''],
      route: [''],
      expected_delivery_date: [null, Validators.required],
      dispatch_date: [null, Validators.required],
      driver_name: ['', Validators.required],
      other_driver_name: [''],
      driver_mobile_no: ['', Validators.required],
      vehicle_type: ['', Validators.required],
      vehicle_number: ['', Validators.required],
      other_vehicle_type: [''],
      other_vehicle_number: [''],
      schedule_delivery: [''],
      uqc_code: [''],
    },{
      validators: [this.grossWeightValidator]
      // this.dateLessThan('dispatch_date', 'expected_delivery_date')
    });

    this.createShipmentAsnForm.get('deliver_to')?.setValue(this.plantInPo);
    this.getDriverList();
    this.getPlantList();
    this.getVendorMasterList();
    this.getDistanceList();
    this.getPOList()

    this.cols3 = [
      { field: 'plant', header: 'Plant' },
      { field: 'poagreementNo', header: 'PO/Agreement No' },
      { field: 'shipmentDate', header: 'Delivery Date' },
      { field: 'name', header: 'Name' },
      { field: 'itemNo', header: 'Item NO	' },
      { field: 'quantity', header: 'Quantity' },
      { field: 'batch_no', header: 'Batch No' },
      { field: 'actual_quantity', header: 'Batch Quantity	' },
      { field: 'uom', header: 'UoM' },
      { field: 'material_code', header: 'Material Code' },
    ];
  }

  getPOList() {
    this.purchaseOrder.getPoList().then((res) => {
      const selectedPoNumbers = this.selectedRows.map((element: SelectedRow) => element.poagreement_no);
      const filteredMessages = res.message.filter((element: { po: { poagreement_no: string; }; }) => {
        return selectedPoNumbers.includes(element.po.poagreement_no);
      });
      filteredMessages.forEach((element: { po: { plant: any; }; }) => {
        this.plantInPo.push(element.po.plant)
      });
      this.selectedPlants = this.plantList.filter(plant => this.plantInPo.includes(plant.name));
    }).catch((error) => {
      console.log(error);
    });
  }

  loadExistingInvoices(): void {
    this.shipment_asn.getInvoiceList().then((response: any) => {
      if (response && response.message && Array.isArray(response.message)) {
        this.existingInvoices = response.message;
        for (const name of this.existingInvoices) {
          const parts = name.split('-');
           this.middlePortion = parts[1];
      }
      } else {
        console.error('Invalid response format or missing data');
      }
    })
  }

  validateInvoice = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const invoice = control.value;
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const vendor_code = this.middlePortion;
      const name = `${invoice}-${vendor_code}-${currentYear}`;
      const existsInDatabase = this.existingInvoices.includes(name);
      if (existsInDatabase) {
        return { existingInvoice: true };
      }
      return null;
    };
  };

  grossWeightValidator(formGroup: FormGroup) {
    const netWeight = formGroup.get('total_net_weight')?.value;
    const grossWeight = formGroup.get('total_gross_weight')?.value;

    if (grossWeight && netWeight && parseFloat(grossWeight) < parseFloat(netWeight)) {
        formGroup.get('total_gross_weight')?.setErrors({ 'grossWeightLessThanNetWeight': true });
    } else {
        formGroup.get('total_gross_weight')?.setErrors(null);
    }
}

// dateLessThan(from: string, to: string) {
//   return (group: FormGroup): { [key: string]: any } => {
//     let f = group.controls[from];
//     let t = group.controls[to];
//     if (f.value && t.value && f.value > t.value) {
//       return { dates: 'Dispatch date should be earlier than expected delivery date' };
//     }
//     return {};
//   };
// }

  filteredUQC(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let UQC = event.query;

    for (let i = 0; i < (this.UQCCode as any[]).length; i++) {
      let UQCCode = (this.UQCCode as any[])[i];
      if (UQCCode.toLowerCase().indexOf(UQC.toLowerCase()) == 0) {
        filtered.push(UQCCode);
      }
    }

    this.filteredUQCCode = filtered;
  }

  filtereVehicleNo(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let vehicleNo = event.query;

    for (let i = 0; i < (this.vehicleNoList as any[]).length; i++) {
      let vehicleData = (this.vehicleNoList as any[])[i];
      if (vehicleData.vehicle_no.toLowerCase().indexOf(vehicleNo.toLowerCase()) == 0) {
        filtered.push(vehicleData);
      }
    }

    this.vehicleListOfData = filtered;
    if (filtered.length === 0) {
      this.createShipmentAsnForm.get('vehicle_number')?.setValue(vehicleNo)
    }
  }

  filtereDriverName(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let driverInputVal = event.query;

    for (let i = 0; i < (this.driverList as any[]).length; i++) {
      let driverData = (this.driverList as any[])[i];
      if (driverData.name.toLowerCase().indexOf(driverInputVal.toLowerCase()) == 0) {
        filtered.push(driverData);
      }
    }

    this.DriverListOfData = filtered;
    if (filtered.length === 0) {
      this.createShipmentAsnForm.get('driver_name')?.setValue(driverInputVal)
    }
  }

  getDriverList() {
    this.shipment_asn
      .getDriverList()
      .then((res) => {
        this.driverList = [...res];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getPlantList() {
    this.shipment_asn
      .getPlantList()
      .then((res) => {
        this.plantList = res;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getVendorMasterList() {
    this.shipment_asn
      .getVendorMasterAddresses()
      .then((res) => {
        this.deliverFromList = res.message.new_address_detail_list;
        this.createShipmentAsnForm.patchValue({
          deliver_from: res.message.primary_address,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getDistanceList() {
    this.shipment_asn
      .getDistanceList()
      .then((res) => {
        this.routeList = res;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  enforceCharacterLimit(event: any): void {
    const inputValue: string = event.target.value;
    let maxLength = 13;

    const validPattern = /^\+?\d*$/;

    if (!validPattern.test(inputValue)) {
      event.target.value = '';
      this.createShipmentAsnForm.get('driver_mobile_no')!.setValue('');
      return;
    }

    if (!inputValue.startsWith('+')) {
      maxLength = 12;
    }

    if (inputValue.length > maxLength) {
      event.target.value = inputValue.substr(0, maxLength);
      this.createShipmentAsnForm
        .get('driver_mobile_no')!
        .setValue(event.target.value);
    }
  }

  onSelectDriver(driver: any) {
    this.driverOtherSelected = false;
    this.createShipmentAsnForm.get('driver_mobile_no')?.setValue(driver.mobile_no);
    this.createShipmentAsnForm.get('driver_name')?.setValue(driver.name);
  }

  onSelectVehicleNo(vehicleNo: any) {
    this.vehicleOtherSelected = false;
    this.createShipmentAsnForm.get('vehicle_number')?.setValue(vehicleNo.name);
  }


  onSelectRoute(route: any) {
    this.currentRount=route
    const travelDuration = parseInt(route.travel_duration, 10);
    const uom = route.uom_hrsdays;

    if (uom === 'Hrs') {
      const hours = travelDuration % 24;
      const days = Math.floor(travelDuration / 24);

      this.duration = `${days} days ${hours} hr`;
    } else if (uom === 'Days') {
      const expectedDeliveryDate = addDays(new Date(), travelDuration);
      const currentDate = new Date();
      const daysDifference = differenceInDays(expectedDeliveryDate, currentDate);
      const hoursDifference = differenceInHours(expectedDeliveryDate, addDays(currentDate, daysDifference));

      this.duration = `${daysDifference} days ${hoursDifference} hr`;
    }

    const expectedDeliveryDate = uom === 'Hrs' ? addHours(new Date(), travelDuration) : addDays(new Date(), travelDuration);
    this.createShipmentAsnForm.patchValue({
      expected_delivery_date: expectedDeliveryDate
    });
  }

  onDispatchDate(dispatchDate: Date) {
    this.minDateValue=dispatchDate
    const travelDuration = parseInt(this.currentRount.travel_duration, 10);
    const uom = this.currentRount.uom_hrsdays;

    if (uom === 'Hrs') {
      const hours = travelDuration % 24;
      const days = Math.floor(travelDuration / 24);

      this.duration = `${days} days ${hours} hr`;
    } else if (uom === 'Days') {
      const expectedDeliveryDate = addDays(new Date(), travelDuration);
      const currentDate = new Date();
      const daysDifference = differenceInDays(expectedDeliveryDate, currentDate);
      const hoursDifference = differenceInHours(expectedDeliveryDate, addDays(currentDate, daysDifference));

      this.duration = `${daysDifference} days ${hoursDifference} hr`;
    }

    const expectedDeliveryDate = uom === 'Hrs' ? addHours(dispatchDate, travelDuration) : addDays(dispatchDate, travelDuration);
    this.createShipmentAsnForm.patchValue({
      expected_delivery_date: expectedDeliveryDate
    });
  }

  formatDate = (date: Date): any => {
    if (date !=null && date != undefined) {
      const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return null
  };
  onSubmit() {
    if (this.createShipmentAsnForm.valid) {
      const formValues = this.createShipmentAsnForm.value;
      // const format = (date: any) =>
      //   date ? this.datePipe.transform(date, 'yyyy-MM-dd') : '';
      const format = (date: any) => {
        if (!date) return '';
        return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
      };

      const plantList = formValues.deliver_to.map((element: { name: any }) => element.name).join(', ');

      this.shipmentASN = {
        serial_no_and_batch: formValues.serial_no_and_batch,
        invoice_challan_no: formValues.invoice_challan_no,
        invoice_date: this.formatDate(formValues.invoice_date),
        actual_delivery_date_and_time: this.formatDate(formValues.actual_delivery_date_and_time),
        deliver_to: plantList,
        deliver_from: formValues.deliver_from,
        expected_delivery_date: this.formatDate(formValues.expected_delivery_date),
        dispatch_date: this.formatDate(formValues.dispatch_date),
        packing_type: formValues.packing_type,
        total_number: formValues.total_number,
        total_gross_weight: formValues.total_gross_weight,
        total_net_weight: formValues.total_net_weight,
        route: formValues.route.name || '',
        driver_name: formValues.driver_name,
        other_driver_name: formValues.other_driver_name,
        driver_mobile_no: formValues.driver_mobile_no,
        vehicle_type: formValues.vehicle_type,
        vehicle_number: formValues.vehicle_number,
        other_vehicle_number: formValues.other_vehicle_number,
        other_vehicle_type: formValues.other_vehicle_type,
        schedule_delivery: this.selectedScopes,
        uqc_code: formValues.uqc_code,
      };

      if (this.shipmentASN) {
        this.shipment_asn
          .createShipmentASN(this.shipmentASN)
          .then((res) => {
            const message = res.message;
            this.invoice=message.data.invoice
            this.selectedASNForPdf={
              invoice:this.invoice.split('-')[0],
              packing_type:message.data.packing_type,
              total_number:message.data.total_number,
              total_net_weight:message.data.total_net_weight,
              total_gross_weight:message.data.total_gross_weight,
              driver:message.data.driver,
              vehicle:message.data.vehicle,
              deliver_from:message.data.deliver_from,
              deliver_to:message.data.deliver_to,
              route:message.data.route,
              expected_delivery_date:message.data.expected_delivery_date
            }
            this.asn_name=message.asn
            this.plant=message.data.deliver_to
            this.vendor=message.vm

            this.invoice_callan_no = this.invoice.split('-')[0];
            if (message.message === "Failed to create Shipment ASN: local variable 'schedule_batch' referenced before assignment") {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'You Have Already Created ASN for selected schedules',
              });
            } else {
              const severity = message.status === 'Success' ? 'success' : 'error';
              this.messageService.add({
                severity,
                summary: severity === 'success' ? 'Success' : 'Error',
                detail: message.message,
              });
              this.selectedASNScheduleDeliveries = [];
              this.shipment_asn.getASNDetail(this.asn_name).then((res)=>{
                this.selectedASNScheduleDeliveries=res.message[0].asn_schedules
              }).catch((e)=>{
                console.log(e)
              })
              if(message.status === 'Success') {
                this.createShipmentAsnForm.reset();
                this.isTokenCreateDialog=true
              }

            }
          })
          .catch((error) => {
            console.log(error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'An error occurred while creating the delivery schedule.',
            });
            // this.createShipmentAsnForm.reset();
          });
      }
    } else {
      this.createShipmentAsnForm.markAllAsTouched();
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill in all required fields.' });
    }
  }

  async generatePdfWithQRCode() {
    this.isTokenCreateDialog = false
    const doc = new jsPDF();

    // Page 1
    // Extract only the 'generated_token_no' field for QR code
    const qrText = `Advanced Shipping Notice: ${this.asn_name}`;

    // Calculate position for QR code in the top-left corner
    const qrCodeSize = 30; // Size of the QR code image
    const margin = 10; // Margin from the edges of the page
    const qrCodeX = margin; // Adjusted position for top-left corner
    const qrCodeY = margin; // Adjusted position for top-left corner

    // Add QR code to PDF
    const qrCodeDataUrl = await QRCode.toDataURL(qrText);
    doc.addImage(qrCodeDataUrl, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

    // Print Token number next to the QR code
    const tokenText = `Advanced Shipping Notice`;
    const tokenTextWidth = tokenText.length * 0.12; // Estimation based on font size and text length
    const tokenTextX = qrCodeX + qrCodeSize + margin;
    const tokenTextY = qrCodeY + qrCodeSize / 2 + 5; // Adjusted vertically to center the text
    doc.text(tokenText, tokenTextX, tokenTextY);

    // Set starting position for fields below the QR code and token number
    let yPos = qrCodeY + qrCodeSize + margin * 2; // Adjusted to leave some space
    const lineHeight = 7; // Decreased line height for smaller text
    const fieldWidth = 60;

    // Set page borders
    doc.setDrawColor(0); // Black color
    doc.setLineWidth(0.2); // Border width
    doc.rect(5, 5, doc.internal.pageSize.getWidth() - 10, doc.internal.pageSize.getHeight() - 10, 'S'); // Draw border around the page

    // Add form values to PDF in table form (excluding 'generated_token_no')
    doc.setFontSize(10); // Decrease font size
    for (const [key, value] of Object.entries(this.selectedASNForPdf)) {
      if (key !== 'generated_token_no') {
        const formattedFieldName = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        doc.text(`${formattedFieldName}:`, 10, yPos);
        doc.text(`${value}`, 80, yPos);
        doc.line(10, yPos + 2, doc.internal.pageSize.getWidth() - 10, yPos + 2); // Extend line till the end of the page
        yPos += lineHeight;
      }
    }

    // Add new page for the table
    // doc.addPage();

    // Set start position for table
    const startY = 150;

    // Table code
    autoTable(doc, {
      head: [
        [
          'Plant',
          'PO No',
          'Delivery Date',
          'Name',
          'Item NO',
          'Qty',
          'Batch No',
          'Batch Quantity',
          'UoM',
          'Material Code',
        ],
      ],
      body: this.selectedASNScheduleDeliveries.map((row) =>
        this.cols3.map((col) => row[col.field])
      ),
      startY: startY,
      theme: 'striped',
      styles: { cellPadding: 3, fontSize: 7, halign: 'left' },
      headStyles: { halign: 'left' },
      didParseCell: function (data: any) {
        let text = typeof data.cell.text === 'string' ? data.cell.text : '';
        let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1;
        if (doc.internal.pageSize.width < colWidth + 20) {
          doc.internal.pageSize = {
            width: colWidth + 25,
            getWidth: () => colWidth + 25,
            height: doc.internal.pageSize.height,
            getHeight: () => doc.internal.pageSize.height,
          };
        }
      },
    });

    // Save the PDF
    doc.save('asn.pdf');
    // this.createTokenForm.reset();
  }

  tokenCreateDialog(){
    const navigationExtras: NavigationExtras = {
      state: {
        asn_no: this.asn_name,
        plant: this.plant,
        vendor:this.vendor,
        invoice:this.invoice,
        invoice_callan_no:this.invoice_callan_no
      }
    };
    this.router.navigate(['/token'],navigationExtras);
  }
}
